import PropTypes from "prop-types";
import React from "react";
import { View } from "react-native";
import Form from "../Form";
import ErrorMessage from "./Layout/ErrorMessage";
import InputLabel from "./Layout/InputLabel";
import types from "./Layout/inputTypes";

export default function SubForm(props, context) {
	var onChange = props.onChange;
	var schema = props.schema;
	var defaultValue = props.defaultValue || {};
	var defaultData = props.defaultData || {};
	var propertyName = props.name;
	var contrast = props.contrast;
	var dataId = props.dataId;
	var errors = props.errors || [];
	var topErrors = errors.filter(function (error) {
		return error.field.length === 0;
	});
	const platform = props.platform;
	const showCustomAddButton = props.showCustomAddButton;

	var label = schema.description ? <InputLabel schema={schema} /> : null;

	var id_prefix = props.id_prefix;

	return (
		<View key={propertyName}>
			{label}
			<ErrorMessage id={context.id_prefix + props.id + "_error"} errors={topErrors} schema={schema} />
			<Form
				id_prefix={id_prefix + propertyName + "_"}
				schema={schema}
				onSubmit={onChange}
				dataId={dataId}
				defaultData={{ ...defaultValue, ...defaultData }}
				autoSubmit
				contrast={contrast}
				errors={errors}
				subForm={true}
				platform={platform}
				showCustomAddButton={showCustomAddButton}
			/>
		</View>
	);
}

SubForm.propTypes = types;

SubForm.contextTypes = {
	id_prefix: PropTypes.string
};
